import React from 'react';
import { Link } from 'react-router-dom';

const OrderSuccess = () => (
    <div className="text-center py-16 min-h-[50vh] flex flex-col justify-center items-center bg-gray-50">
        <div className="bg-white p-10 rounded-lg shadow-lg">
            <h1 className="text-4xl font-bold text-green-600 mb-4">🎉 Order Placed Successfully!</h1>
            <p className="text-gray-700 text-lg mb-8">Your order will be shipped soon. Thank you for shopping with LumioTec!</p>
            <Link 
                to="/" 
                className="mt-6 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-transform transform hover:scale-105"
            >
                Continue Shopping
            </Link>
        </div>
    </div>
);

export default OrderSuccess;
